import { gql as o } from "@apollo/client";
const a = o`
  mutation Logout {
    logout
  }
`;
export {
  a as default
};
//# sourceMappingURL=logout.js.map
